import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HistoryIcon from '@material-ui/icons/History';
import CachedIcon from '@material-ui/icons/Cached';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import MenuIcon from '@material-ui/icons/Menu';
import Group from '@material-ui/icons/Group';
import CreditCard from '@material-ui/icons/CreditCard';
import NotificationsActive from '@material-ui/icons/NotificationsActive';
import LocalActivity from '@material-ui/icons/LocalActivity';
import Error from '@material-ui/icons/Error';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import LocalAtm from '@material-ui/icons/LocalAtm';
import TrendingUp from '@material-ui/icons/TrendingUp';
import AddCircle from '@material-ui/icons/AddCircle';
import AccountBalance from '@material-ui/icons/AccountBalance';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import Face from '@material-ui/icons/Face';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import Explore from '@material-ui/icons/Explore';
import ListIcon from '@material-ui/icons/List';
import './menu.css';
import Collapse from '@material-ui/core/Collapse';
import Backspace from '@material-ui/icons/Backspace';


const useStyles = makeStyles((theme) => ({
    nested: { paddingLeft: theme.spacing(4) }
}));

export default function Menu() {
    const [state, setState] = React.useState({
        show: false,
        showCashback: false,
        showExchange_rates: false,
        showExplorer: false,
        showExchange_ways: false,
        showNft: false,
        showUser_data: false
    });
    const classes = useStyles();

    const toggleDrawer = (show) => () => setState(state => { return { ...state, show }; });

    const handleClick = (paramName) => () => {
        paramName = paramName.slice(0, 1) + paramName.slice(1).toLowerCase();
        const newState = { ...state };
        newState[ 'show' + paramName ] = !newState[ 'show' + paramName ];
        setState(() => { return newState; });
    };

    const renderMenu = () => {
        return (
            <div className="menu__content" >
                <List>
                    <Link className="menu__content_link" to="/skr/history" >
                        <ListItem button>
                            <ListItemIcon> <HistoryIcon/> </ListItemIcon>
                            <ListItemText primary="History" />
                        </ListItem>
                    </Link>
                    {/* <Link className="menu__content_link" to="/skr/exchange-ways" >
                        <ListItem button>
                            <ListItemIcon> <CachedIcon/> </ListItemIcon>
                            <ListItemText primary="Exchange ways" />
                        </ListItem>
                    </Link> */}
                    <Link className="menu__content_link" to="/skr/order-info" >
                        <ListItem button>
                            <ListItemIcon> <AssignmentInd/> </ListItemIcon>
                            <ListItemText primary="Order info" />
                        </ListItem>
                    </Link>
                    
                    <ListItem button onClick={ handleClick('User_data') }>
                        <ListItemIcon> <Face/> </ListItemIcon>
                        <ListItemText primary="User data" />
                        { state.showUser_data ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showUser_data } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/user-data/sum-sub-status" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <Group/> </ListItemIcon>
                                    <ListItemText primary="SumSub status" />
                                </ListItem>
                            </Link>
                            <Link className="menu__content_link" to="/skr/user-data/card-info" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <CreditCard/> </ListItemIcon>
                                    <ListItemText primary="Check card for uniqueness" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>

                    {/* EXCHANGE WAYS */}
                    <ListItem button onClick={ handleClick('EXCHANGE_WAYS') }>
                        <ListItemIcon> <AutorenewIcon/> </ListItemIcon>
                        <ListItemText primary="Exchange ways" />
                        { state.showExchange_ways ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showExchange_ways } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/exchange-ways/matrix" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <ViewModuleIcon/> </ListItemIcon>
                                    <ListItemText primary="Matrix" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>

                    {/* EXCHANGE RATES */}
                    <ListItem button onClick={ handleClick('EXCHANGE_RATES') }>
                        <ListItemIcon> <TrendingUp/> </ListItemIcon>
                        <ListItemText primary="Exchange rates" />
                        { state.showExchange_rates ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showExchange_rates } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/exchange-rates/cashback-fee" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <AddCircle/> </ListItemIcon>
                                    <ListItemText primary="Cashback fee" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>

                    {/* CASHBACK */}
                    <ListItem button onClick={ handleClick('CASHBACK') }>
                        <ListItemIcon> <LocalAtm/> </ListItemIcon>
                        <ListItemText primary="Cashback" />
                        { state.showCashback ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showCashback } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/cashback/referral-structure" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <Group/> </ListItemIcon>
                                    <ListItemText primary="Referral structure" />
                                </ListItem>
                            </Link>
                            <Link className="menu__content_link" to="/skr/cashback/promo" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <LocalActivity/> </ListItemIcon>
                                    <ListItemText primary="Promo" />
                                </ListItem>
                            </Link>
                            <Link className="menu__content_link" to="/skr/cashback/balances-statistics" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <AccountBalance/> </ListItemIcon>
                                    <ListItemText primary="Balance statistics" />
                                </ListItem>
                            </Link>
                            <Link className="menu__content_link" to="/skr/cashback/multiple-balances-reset" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <Backspace/> </ListItemIcon>
                                    <ListItemText primary="Multiple balances reset" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>

                    <Link className="menu__content_link" to="/skr/push-notifications" >
                        <ListItem button>
                            <ListItemIcon> <NotificationsActive/> </ListItemIcon>
                            <ListItemText primary="Push notifications" />
                        </ListItem>
                    </Link>
                    {/* <Link className="menu__content_link" to="/skr/report-by-period" >
                        <ListItem button>
                            <ListItemIcon> <Timeline/> </ListItemIcon>
                            <ListItemText primary="Report by period" />
                        </ListItem>
                    </Link> */}
                    <Link className="menu__content_link" to="/skr/error-orders" >
                        <ListItem button>
                            <ListItemIcon> <Error/> </ListItemIcon>
                            <ListItemText primary="Error orders" />
                        </ListItem>
                    </Link>

                    {/* EXPLORER */}
                    <ListItem button onClick={ handleClick('EXPLORER') }>
                        <ListItemIcon> <Explore/> </ListItemIcon>
                        <ListItemText primary="Explorer" />
                        { state.showExplorer ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showExplorer } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/explorer/transaction-check" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <ListIcon/> </ListItemIcon>
                                    <ListItemText primary="Tx check" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>

                    {/* <Link className="menu__content_link" to="/skr/nft-info" >
                        <ListItem button>
                            <ListItemIcon> <Info/> </ListItemIcon>
                            <ListItemText primary="NFT Info" />
                        </ListItem>
                    </Link> */}


                    <ListItem button onClick={ handleClick('NFT') }>
                        <ListItemIcon> <LocalAtm/> </ListItemIcon>
                        <ListItemText primary="NFT" />
                        { state.showNft ? <ExpandLess /> : <ExpandMore /> }
                    </ListItem>
                    <Collapse in={ state.showNft } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link className="menu__content_link" to="/skr/nft-info" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <Group/> </ListItemIcon>
                                    <ListItemText primary="Search for a contract" />
                                </ListItem>
                            </Link>
                            <Link className="menu__content_link" to="/skr/nft-scanner" >
                                <ListItem button className={ classes.nested }>
                                    <ListItemIcon> <AccountBalance/> </ListItemIcon>
                                    <ListItemText primary="Transaction scanner" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>
                </List>
            </div>
        );
    };

    return (
        <div className="menu__wrapper">
            <button className="menu__open_button" onClick={ toggleDrawer(true) }>
                <MenuIcon style={ style.menuIcon }/>
            </button>

            <SwipeableDrawer
            anchor="left"
            open={state.show}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}>
                { renderMenu() }
            </SwipeableDrawer>
        </div>
    );
}

const style = {
    menuIcon: { fontSize: 40, color: "#693494" }
};
